import { ConfirmModal } from '@/components/ui'
import { ExclamationCircleOutlined } from '@ant-design/icons'

interface DeleteConfirmModalProps {
  visible: boolean
  scanPointName: string
  onConfirm: () => void
  onCancel: () => void
}

export default function DeleteConfirmModal({
  visible,
  onConfirm,
  onCancel
}: DeleteConfirmModalProps) {
  return (
    <ConfirmModal
      title="Delete Scan Point"
      open={visible}
      onConfirm={onConfirm}
      onClose={onCancel}
      confirmText="Delete"
      danger
    >
      <div className="flex items-start gap-3">
        <ExclamationCircleOutlined className="text-2xl text-orange-500 mt-1" />
        <div>
          <p className="text-sm text-gray-600">
            Are you sure you want to delete this scan point? All scan logs associated with this point will also be permanently removed.
          </p>
        </div>
      </div>
    </ConfirmModal>
  )
}
